export default __webpack_public_path__ + "static/platform-0777a2a41f69174eb0b31582c3b9bfe2.webp";